import gql from 'gql-tag'

export const UPDATE_QUESTIONNAIRE_RESPONSE = gql`
  mutation UpdateQuestionnaireResponse($responseId: ID!, $resource: QuestionnaireResponseCreate!) {
    QuestionnaireResponseUpdate(id: $responseId, res: $resource) {
      id
      status
      authored
      meta {
        lastUpdated
      }
    }
  }
`
